// extracted by css-extract-rspack-plugin
export default {"map":"map--U79naTqE_7JhnYys","mapHidden":"map_hidden--bBnBFB86_WspcjCZ","loader":"loader--Qluu5zoA1gqQZAV1"};